import { axios } from '@Root/API'

export const get = (studyProgrammeId, fundingBodyId) => {
	return axios.get(`course-session/${studyProgrammeId}/funding-body/${fundingBodyId}`)
}
